import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useApp } from '../context/AppContext';
import { ROLES } from '../mock';
import { AktaLogo } from '../components/AktaLogo';
import { AlertCircle } from 'lucide-react';

const homeForRole = (role) => role === ROLES.ADMIN ? '/admin' : role === ROLES.SALES_HEAD ? '/sales' : '/dashboard';

const AuthCallbackPage = () => {
  const location = useLocation();
  const nav = useNavigate();
  const { finishGoogleLogin } = useApp();
  const [error, setError] = React.useState('');
  const processed = React.useRef(false);

  React.useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = location.hash || '';
    const params = new URLSearchParams(hash.startsWith('#') ? hash.slice(1) : hash);
    const sid = params.get('session_id');
    if (!sid) { setError('No session id in URL'); return; }
    (async () => {
      try {
        // clean the fragment so a refresh doesn't retry
        try { window.history.replaceState(null, '', window.location.pathname); } catch { /* noop */ }
        const u = await finishGoogleLogin(sid);
        nav(homeForRole(u.role), { replace: true });
      } catch (e) {
        setError(e?.apiMessage || 'Authentication failed');
      }
    })();
  }, [location.hash, finishGoogleLogin, nav]);

  return (
    <div className="min-h-screen bg-brand-bg flex items-center justify-center p-6">
      <div className="w-full max-w-md rounded-xl border border-brand-border bg-white p-8 text-center">
        <div className="flex justify-center mb-4"><AktaLogo size={56} showText={false} /></div>
        {error ? (
          <>
            <div className="flex items-center justify-center gap-2 text-red-700 font-semibold"><AlertCircle className="h-4 w-4" /> Sign-in failed</div>
            <p className="text-sm text-muted-foreground mt-2">{error}</p>
            <button onClick={() => nav('/login', { replace: true })} className="mt-6 h-10 px-4 rounded-md bg-brand-indigo text-white font-medium">Back to sign in</button>
          </>
        ) : (
          <>
            <div className="text-brand-indigo font-semibold">Signing you in…</div>
            <p className="text-xs text-muted-foreground mt-2">Verifying your Akta Wealth account</p>
            <div className="mt-6 h-1.5 rounded-full bg-brand-bg overflow-hidden">
              <div className="h-full bg-brand-indigo animate-pulse" style={{ width: '60%' }} />
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default AuthCallbackPage;
